import {createContext, PropsWithChildren, useContext, useMemo} from "react";
import {BaseThemeContext} from "@/theming/BaseThemeProvider";
import {baseTheme} from "@/theming/baseTheme";
import {AppDataOrganization} from "@/data/app-data-interfaces";

export const OrganizationThemeContext = createContext<{theme: typeof baseTheme} | null>(null);

export const OrganizationThemeProvider = ({children, organization}: PropsWithChildren & {organization: AppDataOrganization}) => {
    const baseThemeContext = useContext(BaseThemeContext);

    if (!baseThemeContext) {
        throw new Error('OrganizationThemeProvider must be used within a BaseThemeProvider');
    }

    const {theme} = baseThemeContext;

    // Create merged theme with organization overrides
    const mergedTheme = useMemo(() => {
        if (!organization.colors) {
            return {theme};
        }

        return {
            theme: {
                ...theme,
                colors: {
                    ...theme.colors,
                    ...organization.colors, // Override with organization colors
                }
            }
        };
    }, [organization, theme]);

    return (
        <OrganizationThemeContext.Provider value={mergedTheme}>
            {children}
        </OrganizationThemeContext.Provider>
    );
};
